/**
 * nova-interviews.js
 * FILE: assets/nova-interviews.js
 *
 * FIXED: Thumb moves horizontally (X axis) — slides in from outside
 * the large image toward center as you scroll into the section.
 * Scrolling back reverses it.
 */

(function () {
  'use strict';

  /* ── CONFIG ─────────────────────────────────────────────────
     MAX_OFFSET: max px the thumb travels horizontally.
     SPEED: 0-1. How fast it moves relative to scroll distance.
  ──────────────────────────────────────────────────────────── */
  var MAX_OFFSET = 40;
  var SPEED      = 0.3;

  function findScrollContainer() {
    var candidates = [
      document.querySelector('.page-wrapper'),
      document.querySelector('main'),
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el) continue;
      var style    = getComputedStyle(el);
      var overflow = style.overflow + style.overflowY;
      if (/auto|scroll/.test(overflow)) return el;
    }
    return window;
  }

  function init() {
    var thumbs = document.querySelectorAll('[data-parallax-thumb]');
    if (!thumbs.length) return;

    var scrollContainer = findScrollContainer();

    function update() {
      var viewH = window.innerHeight;

      thumbs.forEach(function (thumb) {
        var rect    = thumb.getBoundingClientRect();

        /*
          progress: 0 when thumb is at bottom of viewport (just entering),
                    1 when thumb is at center of viewport (fully in view).
          We map this to a horizontal translateX offset.

          Direction: read from data attribute set on the element.
          'right' thumb → starts further right (positive X), slides left to 0.
          'left'  thumb → starts further left (negative X), slides right to 0.
        */
        var isLeft   = thumb.classList.contains('nova-iv__thumb-wrap--left');

        /* How far the thumb's center is from the bottom of viewport */
        var centerY  = rect.top + rect.height / 2;
        var progress = 1 - (centerY / viewH);            /* 0=entering, 1=centered */
        progress     = Math.min(Math.max(progress, 0), 1);

        /* Ease-out quadratic */
        var eased    = 1 - Math.pow(1 - progress, 2);

        /*
          At progress 0 (entering viewport from bottom):
            right thumb → offset = +MAX_OFFSET (pushed outward to the right)
            left thumb  → offset = -MAX_OFFSET (pushed outward to the left)
          At progress 1 (centered in viewport):
            both thumbs → offset = 0 (natural position, overlapping large image)
        */
        var direction = isLeft ? -1 : 1;
        var offset    = direction * MAX_OFFSET * (1 - eased);

        thumb.style.transform = 'translateX(' + offset.toFixed(1) + 'px)';
      });
    }

    update();

    var ticking = false;
    scrollContainer.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    /* Also listen on window in case page-wrapper isn't the scroller */
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', update, { passive: true });
  }

  function waitAndInit() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(init);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }

})();